//      
import React, { Component } from 'react';
import styled from 'styled-components';
import { isObject, values } from 'lodash';

import { mergeClassNames, mergeStringsWithSpaces } from 'utils/functions';

export const FormGroup = styled.div.attrs(props => ({
    className: 'form-group',
}))`
    .form-control {
        position: relative;
        width: 100%;
        outline: 0;
        transition: border-color 150ms ease-out;
        &:focus {
            border-color: ${props => props.theme.color.borderPrimary} !important;
        }
        &.is-invalid {
            border-color: ${props => props.theme.color.borderDanger} !important;
        }
        &:disabled {
            background-color: ${props => props.theme.color.gray200} !important;
            color: ${props => props.theme.color.textMuted} !important;
            cursor: not-allowed;
        }
    }
    .input-group .form-control {
        width: auto;
        display: flex;
        flex: 1;
    }
    textarea.with-height-control {
        min-height: 12.5rem;
        @media (max-width: 767px) {
            min-height: 7rem;
        }
    }
`;

                   
                                                
                      
                             
                               
                            
                     
                           
                  
                                                               
                 
                                     
                                                                
                                                       
                    
                                                     
                   
  

/** A wrapper component for rendering text input form fields. */
export class Input extends Component             {
    static defaultProps = {
        type: 'text',
        className: '',
        errorText: '',
        label: '',
        helpText: '',
        name: '',
        prepend: '',
        append: '',
    };

    render() {
        let {
            errorText,
            className,
            helpText,
            label,
            name,
            type,
            prepend,
            append,
            ...domProps
        } = this.props;
        const errorClass = errorText ? 'is-invalid' : '';

        className = mergeClassNames('form-control bg-white', className, errorClass);

        if (errorText && isObject(errorText)) {
            errorText = mergeStringsWithSpaces(values(errorText));
        }

        // when you set min-height on textarea it overrides 'rows' attr,
        // but our form library works with 'rows'. So...
        if (type === 'textarea' && !domProps.rows) {
            className = mergeClassNames(className, 'with-height-control');
        }

        let theInput = type === 'textarea' ? (
            <textarea
                className={`${className}`}
                id={`id_${name}`}
                name={name}
                {...domProps}
            />
        ) : (
            <input
                className={className}
                id={`id_${name}`}
                name={name}
                type={type}
                {...domProps}
            />
        );

        if (prepend || append) {
            theInput = (
                <div className='input-group'>
                    {prepend && <div className='input-group-prepend'><span className='input-group-text'>{prepend}</span></div>}
                    {theInput}
                    {append && <div className='input-group-append'><span className='input-group-text'>{append}</span></div>}
                </div>
            );
        }

        return (
            <FormGroup>
                {label && <label htmlFor={`id_${name}`}>{label}</label>}
                {theInput}
                {errorText && (
                    <small className='form-text text-danger'>{errorText}</small>
                )}
                {helpText && <small className='form-text text-muted'>{helpText}</small>}
            </FormGroup>
        );
    }
}

export default Input;
